import { ColorEnum } from '@/constants/color'
import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

interface ShiftCloseoutIconProps extends SvgProps {
    size?: number
}

const ShiftCloseoutIcon: FC<ShiftCloseoutIconProps> = ({
    fill = ColorEnum.WHITE,
    size = 24,
    ...props
}) => {
    return (
        <Svg {...props} fill={fill} height={size} viewBox="0 0 24 24" width={size}>
            <Path
                d="M11.3169 2.12302C11.4294 2.12302 11.5044 2.02552 11.4819 1.91302L11.2044 0.578017C11.1219 0.188017 10.7394 -0.0669833 10.3419 0.0155167L0.0518637 1.98802C-0.0231363 2.00302 -0.0156367 2.11552 0.0668633 2.11552H11.3169V2.12302Z"
                transform="translate(6.3672, 3.576)"
            />
            <Path
                d="M13.59 9.5025C12.7425 9.5025 12.06 8.82 12.06 7.9725V5.235C12.06 4.3875 12.7425 3.705 13.59 3.705H16.9575C17.1825 3.705 17.37 3.5175 17.37 3.2925V0.727499C17.37 0.322499 17.0475 0 16.6425 0H0.7275C0.3225 0 0 0.322499 0 0.727499V12.495C0 12.9 0.3225 13.2225 0.7275 13.2225H16.635C17.04 13.2225 17.3625 12.9 17.3625 12.495V9.9225C17.3625 9.6975 17.175 9.51 16.95 9.51H13.5825L13.59 9.5025Z"
                transform="translate(3.6744, 6.48)"
            />
            <Path
                d="M4.71 0H0.660001C0.300001 0 0 0.2925 0 0.66V3.3975C0 3.7575 0.292501 4.0575 0.660001 4.0575H4.71C5.07 4.0575 5.37 3.765 5.37 3.3975V0.66C5.37 0.3 5.0775 0 4.71 0ZM1.89 2.91C1.4025 2.91 1.005 2.5125 1.005 2.025C1.005 1.5375 1.4025 1.14 1.89 1.14C2.3775 1.14 2.775 1.5375 2.775 2.025C2.775 2.5125 2.3775 2.91 1.89 2.91Z"
                transform="translate(16.6056, 11.0544)"
            />
        </Svg>
    )
}

export default ShiftCloseoutIcon
